import React, { Component } from 'react';
import cn from 'classnames';
import { string, arrayOf, object, func, bool } from 'prop-types';
import { Button } from 'common/components';
import { Field } from 'redux-form-normalize-on-blur/index';
import { isRequired } from 'common/form-validators';
import './index.css';

class renderField extends Component {
  static propTypes = {
    input: object.isRequired,
    value: bool,
    className: string,
    theme: arrayOf(string),
    leftButton: object.isRequired,
    rightButton: object.isRequired,
    defaultState: object.isRequired,
    disabled: bool,
  };

  state = {
    status: this.props.defaultState || this.props.input.value || false,
  };

  componentDidUpdate(prevProps) {
    const {
      input: { value },
    } = this.props;
    if (prevProps.input.value !== value) {
      this.setState({ status: value });
    }
  }

  _toggleState = status => {
    if (status !== this.state.status) {
      this.props.input.onChange(status);
    }
    this.setState({ status });
  };

  render() {
    const {
      className,
      theme,
      disabled,
      leftButton: { onClick: leftClick, ...leftRest },
      rightButton: { onClick: rightClick, ...rightRest },
    } = this.props;
    const { status } = this.state;
    const ToggleButtonCSS = cn(
      'togglebutton',
      className,
      theme ? theme.map(css => `togglebutton--${css}`).join(' ') : ''
    );

    return (
      <div className={ToggleButtonCSS}>
        <div className="togglebutton__container">
          <Button
            className={cn(
              'btn',
              'btn--secondary',
              'btn--equal',
              'btn--simple',
              'btn--small',
              {
                'btn--inverted': status,
              }
            )}
            disabled={disabled}
            type="button"
            onClick={() => {
              this._toggleState(false);
              leftClick && leftClick();
            }}
            {...leftRest}
          />
          <Button
            className={cn(
              'btn',
              'btn--primary',
              'btn--equal',
              'btn--simple',
              'btn--small',
              {
                'btn--inverted': !status,
              }
            )}
            type="button"
            disabled={disabled}
            onClick={() => {
              this._toggleState(true);
              rightClick && rightClick();
            }}
            {...rightRest}
          />
        </div>
      </div>
    );
  }
}

const ToggleButton = props => {
  const { component = renderField, title, validate, ...rest } = props;

  return (
    <fieldset className={'field'}>
      {title && (
        <label htmlFor={name}>
          {title}
          {isRequired(validate) && ' *'}
        </label>
      )}

      <Field {...rest} validate={validate} component={component} />
    </fieldset>
  );
};

ToggleButton.propTypes = {
  component: func,
  className: string,
  title: string,
  name: string.isRequired,
  validate: arrayOf(func),
};

export default ToggleButton;



// WEBPACK FOOTER //
// ./src/common/components/ToggleButton/index.js